import { Container } from '@acies/core';
import IconTitle from './icon-title';
import { ICONS } from './icons';

export default class IconTitleSectionHeader extends Container {
	public set icon(value: keyof typeof ICONS | null) {
		this.iconTitle.icon = value;
	}

	public get icon(): keyof typeof ICONS | null {
		return this.iconTitle.icon;
	}

	public set text(value: string) {
		this.iconTitle.text = value;
	}

	public get text(): string {
		return this.iconTitle.text;
	}
	#iconTitle!: IconTitle;
	public constructor() {
		super();
		this.alignment = 'left';
		this.gapHorizontal = 'auto';
		this.height = 32;
		this.width = 'fill';
	}

	public get iconTitle(): IconTitle {
		if (!this.#iconTitle) {
			this.#iconTitle = new IconTitle();
		}
		return this.#iconTitle;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.iconTitle]);
	}
}
customElements.define('ac-icon-title-section-header', IconTitleSectionHeader);
